module.exports = __webpack_public_path__ + "static/img/bgLogo.829d4390.png";